import { type Epic } from 'redux-observable';
import { filter } from 'rxjs';
import { navigate as navigateOperator } from '@/utils/operators';
import { navigate } from '../actions';

const navigateEpic: Epic = (action$) =>
  action$.pipe(filter(navigate.match), navigateOperator());

export default navigateEpic;
